import { Pipe, PipeTransform } from '@angular/core';
import { StatutProfessionnel } from '../../models/statutProfessionnel';

@Pipe({
	name: 'filterStatutProfessionnelByName'
})
export class FilterStatutProfessionnelByNamePipe implements PipeTransform {
	transform(statutProfessionnel: StatutProfessionnel[], filter: string): StatutProfessionnel[] {
		if (
			!statutProfessionnel ||
			!filter ||
			statutProfessionnel === null ||
			filter === null ||
			filter === ''
		) {
			return statutProfessionnel;
		}

		return statutProfessionnel.filter((statutProfessionnel: StatutProfessionnel) => {
			if (statutProfessionnel.name) {
				// TODO: add lastName too
				return statutProfessionnel.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
